import BaseService, { IHttpResponse } from '../../../BaseService';
import TokensService from '../../../TokensService/TokensService';
import { IPrepareMediaPlaysUrl, prepareMediaPlaysUrl } from '../BuildUrls';
import { IMediaPlays } from '../Types';

const debug = require('debug')(
  'tca:service:MediaPersonalizationService:MediaPlayService:Core:GetOne'
);

interface IMediaPlaysGetOne extends IPrepareMediaPlaysUrl {
  appKey?: string;
  id: string;
}

interface IMediaPlaysGetOneResponse extends IHttpResponse {
  body?: IMediaPlays;
}

export default async function getOne({
  appKey,
  ...buildUrlProps
}: IMediaPlaysGetOne): Promise<IMediaPlaysGetOneResponse> {
  debug('GetOne');
  const token = await TokensService.getGuestToken();
  const url = prepareMediaPlaysUrl(buildUrlProps);

  return await BaseService.Get({
    url,
    appKey,
    token,
  });
}
